import { createSelector } from '@ngrx/store'
import { RootState } from '../root.model'
import { CashBreakRedux } from './cash-break.reducer'

const cashBreakSettingsState = (state: RootState) => state.cashBreakSettings

export const selectCashBreakAdvancedSettings = createSelector(
  cashBreakSettingsState,
  (state: CashBreakRedux) => state.advancedSettings,
)
